import { TutorPlanSubscriptionCard } from 'components/molecules/TutorPlan/TutorPlanSubscriptionCard';

import { useTutorUser } from 'hooks/useUser';
import React from 'react';

import { Box, Container, Grid, Toolbar } from '@mui/material';
import { TutorMyPlanDownloadApp } from 'components/molecules/TutorPlan/TutorMyPlanDownloadApp';

export const TutorMyplanPlanPage: React.FC = () => {
  document.title = 'Vet4all - Tutor';

  const { planSubscription } = useTutorUser();

  if (!planSubscription) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />

        <Container sx={{ py: 3 }} maxWidth="xl">
          <Grid container spacing={5}>
            <Grid item xs={12} lg={8}>
              <TutorPlanSubscriptionCard planSubscription={planSubscription} />
            </Grid>

            <Grid item xs={12} lg={4}>
              <TutorMyPlanDownloadApp />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};
